<template>
  <pt-batch-operation class="pt-batch-operation__withData"></pt-batch-operation>
</template>

<script>
import PtBatchOperation from './index'
export default {
  name: 'pt-batch-operation__withData',
  components: {
    'pt-batch-operation': PtBatchOperation
  }
}
</script>
